export const config = {
  applicationVersion: import.meta.env.VITE_APPLICATION_VERSION,
  auth0LoginUrl: import.meta.env.VITE_AUTH0_LOGIN_URL,
  auth0LogoutUrl: import.meta.env.VITE_AUTH0_LOGOUT_URL,
  payloadApiEndpoint: import.meta.env.VITE_PAYLOAD_API_ENDPOINT,
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  supportEmailAddress: import.meta.env.VITE_SUPPORT_EMAIL_ADDRESS,
  legalDocumentationUrl: import.meta.env.VITE_LEGAL_DOCUMENTATION_URL
}
